export default {
  overrideRequest: function (axiosConfig) {

  },
  verifytotpfactorasync: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  createtotpfactoruserpassasync: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  verifytotpfactoruserpassasync: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  }
}



// WEBPACK FOOTER //
// ./src/library/rpcService/api/services/Totp.js